<template>
	<div class="desktop-money-page" :class="colourMode">
		<SettingsOverlay
			v-if="showSettings"
			:customer="customer"
			:colourMode="colourMode"
			:safeTop="safeTop"
			@close="showSettings = false"
			@update-pref="updatePref"
			@select-colour-mode="selectColourMode"
		/>
		<Money v-else />
	</div>
</template>

<script>
import Money from '@/components/Money.vue';
import SettingsOverlay from '../components/SettingsOverlay.vue';
import Services from '../../mixins/Services';

export default {
	name: "MoneyPage",
	mixins: [Services],
	components: { Money, SettingsOverlay },
	emits: ['colour-mode-changed'],
	inject: ['registerSidebar'],
	data() {
		return {
			colourMode: 'light',
			userName: 'there',
			showSettings: false
		}
	},
	computed: {
		safeTop() {
			return parseInt(this.$cookies.get('st') ?? 0);
		}
	},
	methods: {
		updatePref(key, value) {
			if (this.customer?.preferences) {
				this.customer.preferences[key] = value;
				this._savePreferences();
			}
		},
		selectColourMode(mode) {
			this.colourMode = mode;
			localStorage.setItem('mg_colour_mode', mode);
			this.$emit('colour-mode-changed', mode);
		}
	},
	mounted() {
		const savedMode = localStorage.getItem('mg_colour_mode');
		if (savedMode) {
			this.colourMode = savedMode;
		} else {
			this.colourMode = 'light';
			localStorage.setItem('mg_colour_mode', 'light');
		}
		this._getCustomer(() => {
			if (this.customer?.person?.firstName) {
				this.userName = this.customer.person.firstName;
			}
		});
		if (this.registerSidebar) {
			this.registerSidebar({
				config: {
					actionButton: null,
					pageItemsTitle: null
				},
				data: this,
				handlers: {
					onActionClick: () => {},
					onPageItemClick: () => {},
					onPageItemDelete: () => {},
					onPageItemRename: () => {},
					onOpenSettings: () => { this.showSettings = true; }
				}
			});
		}
	}
}
</script>

<style scoped>
.desktop-money-page {
	height: 100%;
	overflow-y: auto;
	background: var(--background-color-main);
}
</style>
